module.exports = __webpack_public_path__ + "media/images/mobile/recording-10c01f20d98a2fe6a0f65a084cd9abd3.svg";